export default __webpack_public_path__ + "static/1-1b74874118393bc97a8f78a5e363ca8c.jpeg";